module.exports = __webpack_public_path__ + "static/logo_divoora-ce408f1449606921494f5dda81883db2.png";